module.exports = __webpack_public_path__ + "static/media/intro.7598a72d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro.gif
// module id = 1518
// module chunks = 0